module.exports = __webpack_public_path__ + "static/img/mozycafebar.1c1a2959.png";